import { TableHead, TableRow, TableCell, TableBody, Table, Paper, TableContainer } from "@mui/material"

export const ProgressTable = () => {

    return (
        <TableContainer component={Paper}>
            <Table aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell width={20}>Poziom</TableCell>
                        <TableCell align="center" colSpan={3}>Rozwinięcia</TableCell> 
                    
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>1</TableCell>
                        <TableCell align="left">3 Statystyki</TableCell>
                        <TableCell align="left">2 Atuty</TableCell>
                        <TableCell align="left">1 Zdolność</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>2</TableCell>                        
                        <TableCell align="left" colSpan={1}>4 Statystyki</TableCell>                                                                     
                        <TableCell align="left">3 Atut</TableCell>
                        <TableCell align="left">2 Zdolności</TableCell>                                     
                    </TableRow>
                    <TableRow>
                        <TableCell>3</TableCell>                        
                        <TableCell align="left" colSpan={1}>5 Statystyk</TableCell>                                                                     
                        <TableCell align="left">4 Atut</TableCell>
                        <TableCell align="left">3 Zdolności</TableCell>                                     
                    </TableRow>
                    <TableRow>
                        <TableCell>4</TableCell>                        
                        <TableCell align="left" colSpan={1}>6 Statystyk</TableCell>                                                                     
                        <TableCell align="left">5 Atut</TableCell>
                        <TableCell align="left">4 Zdolności</TableCell>                                     
                    </TableRow>
                    <TableRow>
                        <TableCell>5</TableCell>                        
                        <TableCell align="left" colSpan={1}>7 Statystyk</TableCell>                                                                     
                        <TableCell align="left">6 Atut</TableCell>
                        <TableCell align="left">5 Zdolności</TableCell>                                     
                    </TableRow>
                    <TableRow>
                    <TableCell colSpan={4} align="center">Mistrzostwo</TableCell>                                                         
                    </TableRow>
                </TableBody>
            </Table >
        </TableContainer>
    );
}